import React from 'react';
import { SessionSummaryFieldsFragment, useListSessionsQuery } from '../../../../../../../../../../../generated/core-api/graphql-react-query';

const PAGINATION = 1000;

export default function useListRelatedSessions(session: SessionSummaryFieldsFragment, filterKey: 'externalCallGroupId' | 'externalCallId') {
  const filterValue = session[filterKey];
  const enabled = Boolean(filterValue);
  const data = useListSessionsQuery(
    {
      input: {
        pagination: { limit: PAGINATION },
        [filterKey]: { eq: filterValue },
      },
    },
    {
      enabled,
    },
  );

  const sessions = React.useMemo(() => data.data?.session.search.items.filter((s) => s.id !== session.id && s[filterKey] === filterValue) || [], [data.data, session.id, filterKey, filterValue]);
  if (!enabled || sessions.length === 0) {
    return null;
  }
  return {
    sessions,
    isLoading: data.isLoading,
  };
}
